module.exports = __webpack_public_path__ + "img/pencil.84aa6651.svg";